import "./ETHMX2026.css";
import { ETHMX2026HeroContent } from "./ETHMX2026HeroContent";

function ETHMX2026() {
  return (
    <div className="ETHMX2026-hero w-100" id="hero-ethmx2026">
      <ETHMX2026HeroContent showLanguageToggle />
    </div>
  );
}

export default ETHMX2026;
